import { render, staticRenderFns } from "./FreightTableCarriersTable.vue?vue&type=template&id=00e784df&scoped=true"
import script from "./FreightTableCarriersTable.vue?vue&type=script&lang=js"
export * from "./FreightTableCarriersTable.vue?vue&type=script&lang=js"
import style0 from "./FreightTableCarriersTable.vue?vue&type=style&index=0&id=00e784df&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e784df",
  null
  
)

export default component.exports